<template>
  <p
    class="flex items-center"
    :class="textColor"
  >
    <slot name="prefix" />
    {{ parsedValue > 0 ? '+' : '' }}{{ value }}{{ unit }}
    <slot name="suffix" />
  </p>
</template>
<script setup lang="ts">
import { computed } from 'vue'

interface IProps {
  value: string
  unit?: string
}

const props = defineProps<IProps>()
const parsedValue = computed(() => parseFloat(props.value.replace(/,/g, '')))
const textColor = computed(() => {
  if (parsedValue.value > 0) {
    return 'text-explorer-green'
  }
  if (parsedValue.value < 0) {
    return 'text-explorer-red'
  }
  return 'text-primary/40'
})
</script>

<style scoped lang="scss">

</style>